import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { flattenCategories, getCategoryChain } from "../../utils/categoryUtils";
import { Category } from "../../types";
import { useCategoriesStore } from "../../store/categoriesStore";
import { useProductStore } from "../../store/productStore";

interface BreadcrumbsProps {
  forcedCategoryId?: number;
  productName?: string;
}

function Breadcrumbs({ forcedCategoryId, productName }: BreadcrumbsProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { categories, fetchCategories } = useCategoriesStore(); // Загрузка из хранилища
  const { setFilter } = useProductStore();
  const [chain, setChain] = useState<Category[]>([]);

  const searchParams = new URLSearchParams(location.search);
  const catParam = searchParams.get("category_id");
  const categoryId = forcedCategoryId ?? (catParam ? Number(catParam) : null);

  // Загружаем категории, если они не были загружены
  useEffect(() => {
        try {
          fetchCategories()
        } catch (error) {
          console.error("Ошибка загрузки категорий:", error);
        }
  }, [fetchCategories]);

  // Вычисляем цепочку категорий
  useEffect(() => {
    if (categoryId && categories.length > 0) {
      const categoryChain = getCategoryChain(categories, categoryId);
      setChain(categoryChain);
    }
  }, [categoryId, categories]);

  const handleBreadcrumbClick = (catId: number) => {
    setFilter("category_id", catId);
    setFilter("offset", 0);
    navigate(`/catalog?category_id=${catId}`);
  };

  return (
    <nav className="text-black/25 text-sm mb-4">
      <Link to="/" className="hover:text-black/50">
        Главная
      </Link>

      {!categoryId && !forcedCategoryId && (
        <>
          {" > "}
          <Link to="/catalog" className="hover:text-black/50">
            Каталог
          </Link>
        </>
      )}

      {chain.map((cat, index) => {
        const isLast = index === chain.length - 1 && !productName;
        return (
          <span key={cat.id}>
            {" / "}
            {isLast ? (
              <span>{cat.name}</span>
            ) : (
              <button
                onClick={() => handleBreadcrumbClick(cat.id)}
                className="hover:text-black/50 text-left inline-block"
              >
                {cat.name}
              </button>
            )}
          </span>
        );
      })}

      {productName && (
        <>
          {" / "}
          <span className="text-bold text-black/50">{productName}</span>
        </>
      )}
    </nav>
  );
}

export default Breadcrumbs;
